export default function Legal({ title, subtitle, children }) {
  return (
    <div className="max-w-4xl mx-auto px-6 md:px-12 py-12" data-testid={`legal-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="border-b border-white/10 pb-8 mb-12">
        <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#C5CDD8]">
          Pages légales
        </div>
        <h1 className="font-display mt-3 text-4xl sm:text-5xl font-bold uppercase tracking-tighter text-white">
          {title}
        </h1>
        {subtitle && <p className="mt-2 text-sm text-white/60">{subtitle}</p>}
      </div>
      <div className="prose prose-sm max-w-none text-white [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:tracking-tight [&_h2]:mt-12 [&_h2]:mb-4 [&_h2]:uppercase [&_h2]:tracking-tighter [&_h2]:text-white [&_h3]:font-bold [&_h3]:mt-8 [&_h3]:mb-3 [&_h3]:text-white [&_p]:text-white/70 [&_p]:leading-relaxed [&_p]:my-4 [&_ul]:list-disc [&_ul]:ml-6 [&_ul]:my-4 [&_ul_li]:text-white/70 [&_ul_li]:my-2 [&_strong]:text-white [&_a]:underline [&_a]:text-[#C5CDD8] [&_em]:text-white/60">
        {children}
      </div>
    </div>
  );
}
